// extracted by mini-css-extract-plugin
export default {"page":"Loader_page__uybPe","ldsGrid":"Loader_ldsGrid__y204j"};